export default __webpack_public_path__ + "media/ZeeTV.bd45b84d.svg";